import { ErrorConfig } from '../base';
import i18n from '@/helper/i18n';
const t = i18n.chain;

const CUSTOMED_MESSAGE_KEYS = {
  DEPART_LESS_THAN_2_5_HOURS:
    'Cannot book a flight departing in less than 2 hours and 15 minutes.',
};

const getAALoadDataErrorKey = (error: any) => {
  const messageKey =
    error?.response?.data?.error?.messageKey || error?.messageKey;
  const message = error?.response?.data?.error?.message || error?.message;

  if (message in t.error.aaLoadDataError) {
    return message;
  } else {
    return messageKey;
  }
};

const getErrorMessage = (messageKey: string): string => {
  return t.error.aaLoadDataError?.[messageKey];
};

const getFormattedErrorMessage = (messageKey: string, error: any): string => {
  return getErrorMessage(messageKey);
};

export const aaLoadDataErrorConfig: ErrorConfig<any> = {
  [CUSTOMED_MESSAGE_KEYS.DEPART_LESS_THAN_2_5_HOURS]: {
    getErrorKey: getAALoadDataErrorKey,
    handleError: (error) => {
      return getErrorMessage(CUSTOMED_MESSAGE_KEYS.DEPART_LESS_THAN_2_5_HOURS);
    },
  },
  flightUnavailable: {
    getErrorKey: getAALoadDataErrorKey,
    handleError: (error) => {
      return getErrorMessage('flightUnavailable');
    },
  },
  fareUnavailable: {
    getErrorKey: getAALoadDataErrorKey,
    handleError: (error) => {
      return getErrorMessage('fareUnavailable');
    },
  },
  default: {
    getErrorKey: getAALoadDataErrorKey,
    handleError: (error) => {
      return getFormattedErrorMessage('_default', error);
    },
  },
};
